//region block: pre-declaration
//endregion
function isPoolingDisabled() {
  return false;
}
//region block: exports
export {
  isPoolingDisabled as isPoolingDisabled1inadkvos9bby,
};
//endregion

//# sourceMappingURL=CharArrayPool.web.mjs.map
